exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.form-builder{height:220px;width:470px;position:relative;display:flex;align-items:center;flex-direction:column;border:1px solid #f0f0f0;box-sizing:border-box;overflow-y:auto}.form-builder--empty{background-image:url(" + require("../../../assets/images/form-background.svg") + ");background-repeat:no-repeat}.form-builder__intro-text{position:absolute;top:32px;left:116px;font-family:Open Sans,sans-serif;white-space:pre;font-size:14px;color:#184e78;margin:0}.form-builder__fields-list{width:100%;margin-bottom:8px}.form-builder__add-button{min-height:32px;height:32px;width:128px;margin-top:auto;margin-bottom:16px;font-family:Open Sans,sans-serif;font-weight:600;color:#fff;font-size:14px;line-height:19px;background-color:#184e78;border-radius:4px;border:none;cursor:pointer}.form-builder__add-button--disabled{cursor:not-allowed;color:#184e78;background-color:#fff;border:1px solid #184e78}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Forms/FormBuilder/FormBuilder.scss
// module id = 1565
// module chunks = 0